import {lazy} from '@aboutyou/lazy-imports';
export const SizeRuns = lazy(() =>
  import('./SizeRuns.eager').then(mod => ({default: mod.SizeRuns})),
);
